module.exports = __webpack_public_path__ + "static/media/right-chevron.883c65ca.svg";